import { Box } from '@mui/material';
import React from 'react';
import AboutSecondBanner from './about/\bAboutSecondBanner';
import AboutFifthBanner from './about/AboutFifthBanner';
import AboutFirstBanner from './about/AboutFirstBanner';
import AboutFourthBanner from './about/AboutFourthBanner';
import AboutSixthBanner from './about/AboutSixthBanner';
import AboutThirdBanner from './about/AboutThirdBanner';
import Footer from './Footer';
import MainHeader from './MainHeader';

export default function About() {
  return <>
    <MainHeader />
    <AboutFirstBanner />
    <AboutSecondBanner />
    <AboutThirdBanner />
    <AboutFourthBanner />
    <AboutFifthBanner />
    <AboutSixthBanner />
    <Footer />
  </>
}
